(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5441],{

/***/ 45441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AddressList; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./components/addressList/addressList.module.scss
var addressList_module = __webpack_require__(15673);
var addressList_module_default = /*#__PURE__*/__webpack_require__.n(addressList_module);
// EXTERNAL MODULE: ./node_modules/.pnpm/swiper@8.4.7/node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(59164);
// EXTERNAL MODULE: ./components/addressCard/addressCard.module.scss
var addressCard_module = __webpack_require__(45931);
var addressCard_module_default = /*#__PURE__*/__webpack_require__.n(addressCard_module);
// EXTERNAL MODULE: ./node_modules/.pnpm/remixicon-react@1.0.0_react@18.2.0/node_modules/remixicon-react/NavigationFillIcon.js
var NavigationFillIcon = __webpack_require__(47179);
var NavigationFillIcon_default = /*#__PURE__*/__webpack_require__.n(NavigationFillIcon);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-i18next@12.3.1_i18next@22.5.1_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-i18next/dist/es/index.js + 17 modules
var es = __webpack_require__(53218);
// EXTERNAL MODULE: ./node_modules/.pnpm/remixicon-react@1.0.0_react@18.2.0/node_modules/remixicon-react/More2FillIcon.js
var More2FillIcon = __webpack_require__(44361);
var More2FillIcon_default = /*#__PURE__*/__webpack_require__.n(More2FillIcon);
// EXTERNAL MODULE: ./containers/popover/popover.tsx
var popover = __webpack_require__(71048);
// EXTERNAL MODULE: ./node_modules/.pnpm/remixicon-react@1.0.0_react@18.2.0/node_modules/remixicon-react/EditLineIcon.js
var EditLineIcon = __webpack_require__(62650);
var EditLineIcon_default = /*#__PURE__*/__webpack_require__.n(EditLineIcon);
// EXTERNAL MODULE: ./node_modules/.pnpm/remixicon-react@1.0.0_react@18.2.0/node_modules/remixicon-react/DeleteBinLineIcon.js
var DeleteBinLineIcon = __webpack_require__(13035);
var DeleteBinLineIcon_default = /*#__PURE__*/__webpack_require__.n(DeleteBinLineIcon);
// EXTERNAL MODULE: ./hooks/usePopover.tsx
var usePopover = __webpack_require__(38737);
;// CONCATENATED MODULE: ./components/addressCard/addressCard.tsx









function AddressCard(param) {
    let { data , changeAddress , onEdit , onDelete , isSelected =false  } = param;
    var ref;
    const { t  } = (0,es/* useTranslation */.$G)();
    const [open, anchor, handleOpen, handleClose] = (0,usePopover/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((addressCard_module_default()).container, " ").concat(isSelected && (addressCard_module_default()).selected),
        onClick: ()=>{
            changeAddress(data);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (addressCard_module_default()).body,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (addressCard_module_default()).icon,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((NavigationFillIcon_default()), {
                            size: 20
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: (addressCard_module_default()).title,
                                children: (data === null || data === void 0 ? void 0 : data.title) || t("title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (addressCard_module_default()).description,
                                children: (data === null || data === void 0 ? void 0 : (ref = data.address) === null || ref === void 0 ? void 0 : ref.address) || ""
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: (addressCard_module_default()).moreOptionsButton,
                onClick: (e)=>{
                    e.stopPropagation();
                    handleOpen(e);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((More2FillIcon_default()), {
                    size: 20
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover["default"], {
                open: open,
                anchorEl: anchor,
                onClose: (e)=>{
                    // @ts-ignore
                    e.stopPropagation();
                    handleClose();
                },
                anchorOrigin: {
                    vertical: 30,
                    horizontal: -55
                },
                customStyles: {
                    borderRadius: "10px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (addressCard_module_default()).popoverContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            type: "button",
                            className: (addressCard_module_default()).item,
                            onClick: (e)=>{
                                e.stopPropagation();
                                onEdit(data);
                                handleClose();
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((EditLineIcon_default()), {
                                    size: 16
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t("edit")
                                })
                            ]
                        }),
                        !isSelected && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            type: "button",
                            className: (addressCard_module_default()).item,
                            onClick: (e)=>{
                                e.stopPropagation();
                                if (data === null || data === void 0 ? void 0 : data.id) {
                                    onDelete(data === null || data === void 0 ? void 0 : data.id);
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((DeleteBinLineIcon_default()), {
                                    size: 16
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t("delete")
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/.pnpm/swiper@8.4.7/node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(67222);
// EXTERNAL MODULE: ./hooks/useModal.tsx
var useModal = __webpack_require__(68864);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/dynamic.js
var dynamic = __webpack_require__(34131);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./contexts/settings/settings.context.tsx
var settings_context = __webpack_require__(8854);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+system@5.18.0_@emotion+react@11.14.0_@types+react@18.3.28_react@18.2.0__@emotion+styled@_oja7ubotzrzctrclxreoqqilcu/node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(9120);
// EXTERNAL MODULE: ./hooks/useAddressServices.tsx
var useAddressServices = __webpack_require__(66886);
// EXTERNAL MODULE: ./node_modules/.pnpm/remixicon-react@1.0.0_react@18.2.0/node_modules/remixicon-react/MapPinAddFillIcon.js
var MapPinAddFillIcon = __webpack_require__(26312);
var MapPinAddFillIcon_default = /*#__PURE__*/__webpack_require__.n(MapPinAddFillIcon);
;// CONCATENATED MODULE: ./components/addressList/addressList.tsx













const AddressModal = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(9290), __webpack_require__.e(719), __webpack_require__.e(5469), __webpack_require__.e(30), __webpack_require__.e(8371)]).then(__webpack_require__.bind(__webpack_require__, 24199)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(24199)
            ]
    }
});
function AddressList(param) {
    let { data =[] , changeAddress , withAddNewAddress =true , selectedAddressId =0 , onEditSelectedAddress  } = param;
    var ref, ref1;
    const { t  } = (0,es/* useTranslation */.$G)();
    const { location , address  } = (0,settings_context/* useSettings */.r)();
    const { mutate: deleteAddress  } = (0,useAddressServices/* useDeleteAddress */.P)();
    const isDesktop = (0,useMediaQuery/* default */.Z)("(min-width:1000px)");
    const [isOpenModal, openModal, closeModal] = (0,useModal/* default */.Z)();
    const [editAddress, setEditAddress] = (0,react.useState)(null);
    const localLocation = (editAddress === null || editAddress === void 0 ? void 0 : (ref = editAddress.location) === null || ref === void 0 ? void 0 : ref.join(",")) || location;
    const localAddress = (editAddress === null || editAddress === void 0 ? void 0 : (ref1 = editAddress.address) === null || ref1 === void 0 ? void 0 : ref1.address) || address;
    const handleCloseModal = ()=>{
        closeModal();
        setEditAddress(null);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (addressList_module_default()).container,
                children: [
                    withAddNewAddress && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        className: (addressList_module_default()).addAddressButton,
                        onClick: (e)=>{
                            e.preventDefault();
                            openModal();
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((MapPinAddFillIcon_default()), {
                                size: 28
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("add.new.address")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                        spaceBetween: 12,
                        slidesPerView: "auto",
                        className: (addressList_module_default()).swiper,
                        children: data === null || data === void 0 ? void 0 : data.map((item)=>{
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                className: (addressList_module_default()).swiperSlide,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressCard, {
                                    data: item,
                                    changeAddress: changeAddress,
                                    onEdit: (address)=>{
                                        setEditAddress(address);
                                        openModal();
                                    },
                                    onDelete: (id)=>{
                                        deleteAddress(id);
                                    },
                                    isSelected: selectedAddressId === (item === null || item === void 0 ? void 0 : item.id)
                                })
                            }, item === null || item === void 0 ? void 0 : item.id);
                        })
                    })
                ]
            }),
            isOpenModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressModal, {
                open: isOpenModal,
                onClose: handleCloseModal,
                latlng: localLocation,
                address: localAddress,
                fullScreen: !isDesktop,
                editedAddress: editAddress,
                onClearAddress: ()=>setEditAddress(null),
                onEditSelectedAddress: onEditSelectedAddress
            })
        ]
    });
}


/***/ }),

/***/ 71048:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ PopoverContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90008);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40939);




const Wrapper = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)((param)=>{
    let { customStyles  } = param;
    return {
        "& .MuiBackdrop-root": {
            backgroundColor: "rgba(0, 0, 0, 0)"
        },
        "& .MuiPaper-root": {
            backgroundColor: "var(--secondary-bg)",
            boxShadow: "var(--popover-box-shadow)",
            borderRadius: "25px",
            maxWidth: "100%",
            ...customStyles
        }
    };
});
function PopoverContainer(param) {
    let { children , customStyles , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Wrapper, {
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "left"
        },
        transformOrigin: {
            vertical: "top",
            horizontal: "left"
        },
        customStyles: customStyles,
        ...rest,
        children: children
    });
}


/***/ }),

/***/ 66886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ useDeleteAddress; },
/* harmony export */   "t": function() { return /* binding */ useChangeAddress; }
/* harmony export */ });
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49532);
/* harmony import */ var services_address__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1988);
/* harmony import */ var contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8854);
/* harmony import */ var contexts_auth_auth_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77712);




function useDeleteAddress() {
    const { isAuthenticated , user  } = (0,contexts_auth_auth_context__WEBPACK_IMPORTED_MODULE_3__/* .useAuth */ .a)();
    const queryClient = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQueryClient)();
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useMutation)({
        mutationFn: (id)=>services_address__WEBPACK_IMPORTED_MODULE_1__/* ["default"]["delete"] */ .Z["delete"](id),
        onMutate: async (id)=>{
            await queryClient.cancelQueries("addresses");
            const prevAddresses = queryClient.getQueryData("addresses", {
                exact: false
            });
            queryClient.setQueryData([
                "addresses",
                isAuthenticated,
                user === null || user === void 0 ? void 0 : user.id
            ], (old)=>{
                if (!old) return prevAddresses;
                return old.flatMap((addressList)=>addressList).filter((oldAddress)=>oldAddress.id !== id);
            });
            return {
                prevAddresses
            };
        },
        onError: (_, __, context)=>{
            queryClient.setQueryData("addresses", context === null || context === void 0 ? void 0 : context.prevAddresses);
        }
    });
}
function useChangeAddress() {
    const { isAuthenticated , user  } = (0,contexts_auth_auth_context__WEBPACK_IMPORTED_MODULE_3__/* .useAuth */ .a)();
    const queryClient = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQueryClient)();
    const { updateAddress , updateLocation  } = (0,contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_2__/* .useSettings */ .r)();
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useMutation)({
        mutationFn: (id)=>services_address__WEBPACK_IMPORTED_MODULE_1__/* ["default"].setDefault */ .Z.setDefault(id),
        onMutate: async (id)=>{
            await queryClient.cancelQueries("addresses");
            const prevAddresses = queryClient.getQueryData("addresses", {
                exact: false
            });
            queryClient.setQueryData([
                "addresses",
                isAuthenticated,
                user === null || user === void 0 ? void 0 : user.id
            ], (old)=>{
                if (!old) return prevAddresses;
                return old.flatMap((addressList)=>addressList).map((oldAddress)=>{
                    if (oldAddress.id === id) {
                        var ref;
                        updateAddress((ref = oldAddress.address) === null || ref === void 0 ? void 0 : ref.address);
                        updateLocation("".concat(oldAddress.location.at(0), ",").concat(oldAddress.location.at(1)));
                        return {
                            ...oldAddress,
                            active: true
                        };
                    }
                    return {
                        ...oldAddress,
                        active: false
                    };
                });
            });
        }
    });
}


/***/ }),

/***/ 38737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ usePopover; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);

function usePopover() {
    const [anchorEl, setAnchorEl] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const open = Boolean(anchorEl);
    const handleOpen = (event)=>{
        return setAnchorEl(event === null || event === void 0 ? void 0 : event.currentTarget);
    };
    const handleClose = ()=>setAnchorEl(null);
    return [
        open,
        anchorEl,
        handleOpen,
        handleClose
    ];
}


/***/ }),

/***/ 1988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47137);

const addressService = {
    create: (data)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("dashboard/user/addresses", data).then((res)=>res.data),
    update: (id, data)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].put */ .Z.put("dashboard/user/addresses/".concat(id), data).then((res)=>res.data),
    getAll: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("dashboard/user/addresses", {
            params
        }).then((res)=>res.data),
    setDefault: (id)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("dashboard/user/address/set-active/".concat(id)).then((res)=>res.data),
    delete: (id)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["delete"] */ .Z["delete"]("dashboard/user/addresses/delete?ids[0]=".concat(id)).then((res)=>res.data)
};
/* harmony default export */ __webpack_exports__["Z"] = (addressService);


/***/ }),

/***/ 45931:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"addressCard_container__OThIw","selected":"addressCard_selected__01gnW","body":"addressCard_body__rLZ8J","icon":"addressCard_icon__KjUn5","title":"addressCard_title__I4cjK","description":"addressCard_description__i9W8N","moreOptionsButton":"addressCard_moreOptionsButton__DH0Ie","popoverContainer":"addressCard_popoverContainer__o8wA2","item":"addressCard_item__Zy_Fz"};

/***/ }),

/***/ 15673:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"addressList_container__KfwEf","addAddressButton":"addressList_addAddressButton__Nzb5X","swiper":"addressList_swiper__rKLVt","swiperSlide":"addressList_swiperSlide__FJK_S"};

/***/ }),

/***/ 62650:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(50959);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var EditLineIcon = function EditLineIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M6.414 16L16.556 5.858l-1.414-1.414L5 14.586V16h1.414zm.829 2H3v-4.243L14.435 2.322a1 1 0 0 1 1.414 0l2.829 2.829a1 1 0 0 1 0 1.414L7.243 18zM3 20h18v2H3v-2z' })
  );
};

var EditLineIcon$1 = React__default['default'].memo ? React__default['default'].memo(EditLineIcon) : EditLineIcon;

module.exports = EditLineIcon$1;


/***/ }),

/***/ 26312:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(50959);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var MapPinAddFillIcon = function MapPinAddFillIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M18.364 17.364L12 23.728l-6.364-6.364a9 9 0 1 1 12.728 0zM11 10H8v2h3v3h2v-3h3v-2h-3V7h-2v3z' })
  );
};

var MapPinAddFillIcon$1 = React__default['default'].memo ? React__default['default'].memo(MapPinAddFillIcon) : MapPinAddFillIcon;

module.exports = MapPinAddFillIcon$1;


/***/ }),

/***/ 44361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(50959);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var More2FillIcon = function More2FillIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M12 3c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 14c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-7c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' })
  );
};

var More2FillIcon$1 = React__default['default'].memo ? React__default['default'].memo(More2FillIcon) : More2FillIcon;

module.exports = More2FillIcon$1;


/***/ }),

/***/ 47179:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(50959);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var NavigationFillIcon = function NavigationFillIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M2.9 2.3l18.805 6.268a.5.5 0 0 1 .028.939L13 13l-4.425 8.85a.5.5 0 0 1-.928-.086L2.26 2.911A.5.5 0 0 1 2.9 2.3z' })
  );
};

var NavigationFillIcon$1 = React__default['default'].memo ? React__default['default'].memo(NavigationFillIcon) : NavigationFillIcon;

module.exports = NavigationFillIcon$1;


/***/ })

}]);